export default {
  methods: {
    updateCartAmount (updateBy = 1) {
      const currentCartAmount = this.$store.state.header.headerData.cart?.count ?? 0

      this.$store.commit('header/setCartAmount', Number(currentCartAmount) + updateBy)
    }
  }
}
